var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivate = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Activate",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic-check-circle/Outlined",
    transform: "translate(1.6667, 1.6667)",
    fill: "#0A186E",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8958669,4.79526215 C11.1562164,5.05561167 11.1562154,5.47772166 10.8958659,5.73807119 L6.75929159,9.87464498 C6.64479268,9.98914388 6.49900614,10.0532878 6.34945272,10.0670756 C6.15291189,10.0910451 5.94774119,10.0276011 5.79688263,9.87674255 L3.72859548,7.8084554 C3.46824595,7.54810588 3.46824595,7.12599589 3.72859548,6.86564636 C3.98894501,6.60529683 4.41105499,6.60529734 4.67140452,6.86564636 L6.27703807,8.47128042 L9.95305786,4.79526215 C10.2134074,4.53491262 10.6355174,4.53491262 10.8958669,4.79526215 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,0 C3.28324534,0 0,3.28324534 0,7.33333333 C0,11.3834218 3.28324534,14.6666667 7.33333333,14.6666667 C11.3834218,14.6666667 14.6666667,11.3834218 14.6666667,7.33333333 C14.6666667,3.28324534 11.3834218,0 7.33333333,0 Z M1.33333333,7.33333333 C1.33333333,4.01962484 4.01962484,1.33333333 7.33333333,1.33333333 C10.6470418,1.33333333 13.3333333,4.01962484 13.3333333,7.33333333 C13.3333333,10.6470418 10.6470418,13.3333333 7.33333333,13.3333333 C4.01962484,13.3333333 1.33333333,10.6470418 1.33333333,7.33333333 Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Activate.16de67411a597a391109c32a84be11d2.svg";